import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import Reporticon from '../Icons/shield.svg';
import Questionicon from '../Icons/chat.png';
import Mailicon from '../Icons/mail-fast.png';
import Documenticon from '../Icons/document-text.svg'
import { Provider } from 'react-redux';

function Firstpage() {
  const navigate = useNavigate(); // Initialize useNavigate
  const token = localStorage.getItem('auth_token')

  const handleReportAbuseClick = () => {
    navigate('/ReportMain'); // Navigate to the /report1 route
  };

  const handleQuestionSendClick = () => {
    navigate('/QuestionMain')
  }

  const handleMailBoxClick = () => {
    if(token){
      navigate('/ViewReports')
    }else{
      navigate('/MailboxMain')
    }
  }

  const handleDocumentsClick = () => {
    navigate('/LegalDocuments')
  }


  return (
    <div className="firstpage-content">
      <h1 className="title">Secure Sports Whistleblower Platform</h1>
      <p className="titletext">
        A confidential channel for reporting abuse in sports. Your identity remains protected – we focus on addressing the issues you report.
      </p>
      <div className="chosecontent">
        <div className="contentbox">
          <img src={Reporticon} alt="" />
          <h2>File Report</h2>
          <p>Submit anonymous reports about suspected abuse in sports</p>
          <button onClick={handleReportAbuseClick}>Report abuse</button>
        </div>
        <div className="contentbox">
          <img src={Questionicon} alt="" />
          <h2>Ask a Question</h2>
          <p>Get expert answers about abuse-related concerns</p>
          <button onClick={handleQuestionSendClick}>A Question</button>
        </div>
        <div className="contentbox">
          <img src={Mailicon} alt="" />
          <h2>My Mailbox</h2>
          <p>Track your reports and continue communication.</p>
          <button onClick={handleMailBoxClick}>View Mailbox</button>
        </div>
        <div className="contentbox">
          <img src={Documenticon} alt="" />
          <h2>Legal Documents</h2>
          <p>Please read the documents and continue communication.</p>
          <button onClick={handleDocumentsClick}>View Documents</button>
        </div>
      </div>
    </div>
  );
}

export default Firstpage;
